import ApiService from '@/data/services/ApiService'
import { IAddLocation, ILocation, IUpdateLocation } from '@/data/models/Location'
import { IPaginationQueryParams } from '@/data/models/Pagination'
import { AxiosResponse, AxiosRequestConfig } from 'axios'
import { IPaginatedServiceResponse, IServiceResponse } from '@/data/models/ServiceResponse'

export class LocationApiService extends ApiService {
  /**
   * Returns paginated list of Locations
   */
  static async getAll(): Promise<IPaginatedServiceResponse<ILocation>> {
    return this.axios.get('locations')
      .then((response: AxiosResponse<IPaginatedServiceResponse<ILocation>>) => response.data)
  }

  /**
   * Given data, creates new entry in database
   *
   * @param locationFormData
   */
  static async create(locationFormData: IAddLocation): Promise<IServiceResponse<ILocation>> {
    return this.axios.post('locations', locationFormData)
      .then((response: AxiosResponse<IServiceResponse<ILocation>>) => response.data)
  }

  /**
   * Given data, updates location's entry in database
   *
   * @param data
   */
  static async update(data: IUpdateLocation): Promise<IServiceResponse<ILocation>> {
    return this.axios.put(`locations/${data.id}`, data)
      .then((response: AxiosResponse<IServiceResponse<ILocation>>) => response.data)
  }

  /**
   * Given location's id, deletes event in database
   *
   * @param locationId
   */
  static async delete(locationId: string): Promise<AxiosResponse> {
    return this.axios.delete(`locations/${locationId}`)
  }
}
